import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { StorageActions } from '../actions'
import { appendAttachments } from './appendAttachments'
import { init } from './init'
import { removeAttachments } from './removeAttachments'
import { setAttachments } from './setAttachments'
import { setStorage } from './setStorage'

export function* storageSaga() {
  yield all([
    takeEvery(StorageActions.init, init),
    takeLatest(StorageActions.setStorage, setStorage),
    takeEvery(StorageActions.setAttachments, setAttachments),
    takeEvery(StorageActions.removeAttachments, removeAttachments),
    takeEvery(StorageActions.appendAttachments, appendAttachments),
  ])
}
